import { AppBox, AppButton, AppText, AppTitle } from "../../../../../commons/components";
import AppBorderBox from "../../../../../commons/components/BorderBox";
import { SeasonStatusEnum } from "../../../../../commons/enums/season-status-enum";
import ability from "../../../../../casl/Can";
import { RolePolicyActionEnum } from "../../../../../commons/enums/role-policy-action.enum";
import { FootballMatchDetail } from "../../../../../commons/models/football/football-match-detail";
import { useAppSelector } from "../../../../../hooks/app";
import { ManageFootballTeam } from "../../../../../commons/models/football/admin/manage-football-team";
import { IFootballHostedCompetition } from "../../../../../commons/models/football/interface/i-football-competition";

interface EmptyTeamInviteComponentProps {
  isPastSeason?: boolean;
  onInviteClick?: () => void;
}

export const EmptyTeamInviteComponent = ({ onInviteClick, isPastSeason }: EmptyTeamInviteComponentProps) => {
  const { fetchedCompetition } = useAppSelector((state) => state.fetchedCompetition);
  return (
    <AppBorderBox borderVariant="dashed" p="sm" mx="sm" mb="sm">
      <AppBox alignItems="center" flexDirection="column" justifyContent="center" gap="2xs">
        <AppText fontWeight="semibold">There are not any team invited.</AppText>
        {ability.can(RolePolicyActionEnum.UPDATE, new ManageFootballTeam((fetchedCompetition as IFootballHostedCompetition).hostTeam)) ||
        ability.can(RolePolicyActionEnum.UPDATE, new FootballMatchDetail({ competitionId: fetchedCompetition.id })) ? (
          <>
            {isPastSeason || (
              <>
                {fetchedCompetition.latestSeason &&
                fetchedCompetition.latestSeason.status === SeasonStatusEnum.Active ? (
                  <AppText fontWeight="semibold">
                    Click the "Invite Team" bellow to invite team in the tournament.
                  </AppText>
                ) : (
                  <AppText fontWeight="semibold">
                    To invite a team, you need to start the season first. Click the "Start Season" button above to
                    begin.
                  </AppText>
                )}
                <AppBox displayBlock mt={"xs"}>
                  <AppButton
                    label="Invite Team"
                    onClick={onInviteClick}
                    disabled={
                      !(
                        fetchedCompetition.latestSeason &&
                        fetchedCompetition.latestSeason.status === SeasonStatusEnum.Active
                      )
                    }
                  />
                </AppBox>
              </>
            )}
          </>
        ) : (
          <AppTitle as="h6">No invitation found</AppTitle>
        )}
      </AppBox>
    </AppBorderBox>
  );
};
